import { all } from 'redux-saga/effects';
import authSaga from "./auth/saga";
import usersSaga from "./users/saga";
import decisionsSaga from "./decisions/saga";

export default function* rootSagas() {
    yield all([
        authSaga(),
        usersSaga(),
        decisionsSaga(),
    ]);
}
